import { css } from '@emotion/core';
import { ASSETS_PATH } from '../../config/common.config';

export default css`
  @font-face {
    font-family: 'TradeGothicLTCom';
    font-style: normal;
    font-weight: normal;
    font-display: swap;
    src: url('${ASSETS_PATH}fonts/TradeGothicLTCom.woff') format('woff');
  }

  @font-face {
    font-family: 'TradeGothicLTCom-Cn18';
    font-style: normal;
    font-weight: normal;
    font-display: swap;
    src: url('${ASSETS_PATH}fonts/TradeGothicLTCom-Cn18.woff') format('woff');
  }

  @font-face {
    font-family: 'TradeGothicLTCom-BdCn20';
    font-style: normal;
    font-weight: normal;
    font-display: swap;
    src: url('${ASSETS_PATH}fonts/TradeGothicLTCom-BdCn20.woff') format('woff');
  }
`;
